// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag__most-viewed[data-v-f961be56]{margin-top:5px}", ""]);
// Exports
module.exports = exports;
